"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

var InnerMeasure = _styledComponents.default.span.attrs({
  'aria-hidden': true
}).withConfig({
  displayName: "HiddenMeasure__InnerMeasure",
  componentId: "azp3uk-0"
})(["overflow:hidden;position:absolute;left:0;max-width:100%;visibility:hidden;pointer-events:none;"]); // We want to force popovers to stay closed, so we use ModalTransitionContext to tell popovers that
// they're in a transitioning modal. Weird but effective!


var hidePopoversContextValue = {
  transitioning: true
};
var HiddenMeasure = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(_ModalTransitionContext.ModalTransitionContextProvider, {
    value: hidePopoversContextValue
  }, _react.default.createElement(InnerMeasure, Object.assign({}, props, {
    ref: ref
  })));
});
var _default = HiddenMeasure;
exports.default = _default;
module.exports = exports.default;